import { combineReducers } from 'redux'
import _ from 'lodash'

import * as healthPreAdmissionAppraisalsList from './list'
import * as getHealthPreAdmissionAppraisal from './get'
import * as createHealthPreAdmissionAppraisal from './create'
import * as editHealthPreAdmissionAppraisal from './edit'
import * as deleteHealthPreAdmissionAppraisal from './delete'

const slices = {
  healthPreAdmissionAppraisalsList,
  getHealthPreAdmissionAppraisal,
  createHealthPreAdmissionAppraisal,
  editHealthPreAdmissionAppraisal,
  deleteHealthPreAdmissionAppraisal
}

const healthPreAdmissionAppraisalTypes = _.mapValues(slices, (s) => s.slice.types)
const healthPreAdmissionAppraisalActions = Object.assign({}, ..._(slices).values().map('slice.actions').value())
const healthPreAdmissionAppraisalSagas = _(slices).values().map('slice.sagas').flatten().value()
const healthPreAdmissionAppraisalSelectors = Object.assign({}, ..._(slices).values().map('slice.selectors').value())
const reducers = Object.assign({}, ..._(slices).values().map('default').value())

export {
  healthPreAdmissionAppraisalTypes,
  healthPreAdmissionAppraisalActions,
  healthPreAdmissionAppraisalSagas,
  healthPreAdmissionAppraisalSelectors
}

export default combineReducers(reducers)
